import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "currentColor",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M15.5.25a2.25 2.25 0 0 1 2.25 2.25v13a2.25 2.25 0 0 1-2.25 2.25h-13A2.25 2.25 0 0 1 .25 15.5v-13A2.25 2.25 0 0 1 2.5.25zm-13 1.5a.75.75 0 0 0-.75.75v13c0 .414.336.75.75.75h13a.75.75 0 0 0 .75-.75v-13a.75.75 0 0 0-.75-.75zM14 10.536a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1 0-1.5zm0-4.572a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1 0-1.5z" }, null, -1)
  ]))]))
}
export default { render: render }